import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as styles from './CardRowEmptyState.scss';
import inflection from 'inflection';

var CardRowEmptyState = /*#__PURE__*/function (_Component) {
  _inherits(CardRowEmptyState, _Component);

  var _super = _createSuper(CardRowEmptyState);

  function CardRowEmptyState() {
    _classCallCheck(this, CardRowEmptyState);

    return _super.apply(this, arguments);
  }

  _createClass(CardRowEmptyState, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.wrap
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-folder-open-o ".concat(styles.icon)
      }), /*#__PURE__*/React.createElement("span", {
        className: styles.emptyText
      }, "No ", inflection.titleize(inflection.singularize(this.props.rowName)), " Ads"));
    }
  }]);

  return CardRowEmptyState;
}(Component);

export default CardRowEmptyState;